import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSimCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSimCard2"><Path d="M17.25 2C18.7688 2 20 3.23122 20 4.75V19.25C20 20.7688 18.7688 22 17.25 22H6.75C5.23122 22 4 20.7688 4 19.25V7.99264C4 6.99808 4.39509 6.04425 5.09835 5.34099L7.34099 3.09835C8.04425 2.39509 8.99808 2 9.99264 2H11.5V7.25C11.5 7.66421 11.8358 8 12.25 8C12.6642 8 13 7.66421 13 7.25V2H15.5V7.25C15.5 7.66421 15.8358 8 16.25 8C16.6642 8 17 7.66421 17 7.25V2H17.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSimCard2;
